// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CustomizeBrush.css */

.customize-brush-menu {
  position: fixed;
  max-height: 95vh; 
  overflow-y: auto; 

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 300px;
  text-align: center;
  background-color: var(--tg-theme-bg-color);
  padding: 20px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  z-index: 1101;
  display: flex;
  flex-direction: column;
  align-items: center;

  overflow-x: hidden;

  transition: background-color 0.2s ease;

}

.customize-brush-menu {
  scrollbar-width: thin;
  scrollbar-color: var(--tg-theme-hint-color) var(--tg-theme-bg-color);
}

.customize-brush-menu,
.customize-brush-menu * {
  touch-action: pan-y;
}

.customize-brush-menu.transparent-background {
  background-color: transparent;

  text-shadow: 0px 0px 1px var(--tg-theme-bg-color), 0px 0px 1px var(--tg-theme-bg-color), 0px 0px 1px var(--tg-theme-bg-color);
}

.customize-brush-menu::-webkit-scrollbar {
  display: block;
  width: 8px;
}

.customize-brush-menu::-webkit-scrollbar-track {
  background: var(--tg-theme-bg-color);
}

.customize-brush-menu::-webkit-scrollbar-thumb {
  background-color: var(--tg-theme-hint-color);
  border-radius: 4px;
}



.customize-brush-title {
  color: var(--tg-theme-button-color);
  font-size: 24px;
  margin-bottom: 3px;
}

.customize-brush-about {
  width: 100%;
  min-height: 35px; 
  height: 35px; 
  padding: 8px;
  margin-bottom: 5px;
  box-sizing: border-box;
  border-radius: 2px;
  border: 1px solid var(--tg-theme-hint-color);
  background-color: var(--tg-theme-bg-color);
  color: var(--tg-theme-text-color);
  font-size: 16px;
  resize: vertical; /* Разрешаем менять только высоту */
}

.customize-brush-label {
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  font-size: 15px;
  color: var(--tg-theme-text-color);
  padding: 1px; 
  padding-left: 10px; 
  text-align: left;
}

.customize-brush-preview-row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0px;
  transform: translate(10px);
  justify-content: space-between; 
}

.customize-brush-slider {
  width: 90%;
  margin-top: 10px;
  margin-right: 10%;
  height: 20px;
  background: var(--tg-theme-button-color);
  opacity: 0.7;
  border-radius: 5px;
}

.customize-brush-select {
  width: 100%;
  padding: 8px;
  margin-top: 4px;
  font-size: 16px;
  border-radius: 8px;
}


.texture-selection {
  width: 100%;
  margin-top: 5px;
  text-align: left;
}

.section-title {
  margin-bottom: 10px;
  color: var(--tg-theme-text-color);
  padding-left: 10px; 
}

.texture-options {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.texture-option {
  width: 61px;
  height: 61px;
  background: none;
  color: var(--tg-theme-text-color);
  border: none;
  padding: 7px;
  cursor: pointer;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  box-sizing: border-box;

  border: 5.7px solid;
  border-radius: 10px;
  border-color: rgba(115, 185, 255, 0.3);
}

.texture-option.active {
  color: var(--tg-theme-button-color);
  border: 5.7px solid;
  border-radius: 10px;
  opacity: 1;
  box-sizing: border-box;
}

.texture-option canvas {
  border-radius: 5px;
  width: 50px;
  height: 50px;
  display: block;
}

.texture-option:hover:not(.active) {
  background-color: rgba(154, 154, 154, 0.12);
  border-radius: 12px;
}

.close-button {
  position: absolute;
  top: 0px; /* Отступ от верхнего края */
  right: 0px; /* Отступ от правого края */
  background: none;
  border: none;
  color: gray; /* Цвет крестика */
  font-size: 20px; /* Размер крестика */
  cursor: pointer;
}

.close-button:hover {
  color: darkgray; /* Цвет при наведении */
}

.button-small-icon {
  width: 15px;
  height: 15px;
  vertical-align: middle;
  margin-right: 3px;
  margin-top: -3px;
}

`, "",{"version":3,"sources":["webpack://./src/components/menus/brush/CustomizeBrush.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,QAAQ;EACR,SAAS;EACT,gCAAgC;;EAEhC,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,kBAAkB;;EAElB,sCAAsC;;AAExC;;AAEA;EACE,qBAAqB;EACrB,oEAAoE;AACtE;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;;EAE7B,6HAA6H;AAC/H;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;AACpB;;;;AAIA;EACE,mCAAmC;EACnC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;EAC5C,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;;EAEtB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ,EAAE,4BAA4B;EACtC,UAAU,EAAE,2BAA2B;EACvC,gBAAgB;EAChB,YAAY;EACZ,WAAW,EAAE,kBAAkB;EAC/B,eAAe,EAAE,oBAAoB;EACrC,eAAe;AACjB;;AAEA;EACE,eAAe,EAAE,uBAAuB;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/* CustomizeBrush.css */\r\n\r\n.customize-brush-menu {\r\n  position: fixed;\r\n  max-height: 95vh; \r\n  overflow-y: auto; \r\n\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n\r\n  width: 300px;\r\n  text-align: center;\r\n  background-color: var(--tg-theme-bg-color);\r\n  padding: 20px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\r\n  border-radius: 12px;\r\n  z-index: 1101;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n\r\n  overflow-x: hidden;\r\n\r\n  transition: background-color 0.2s ease;\r\n\r\n}\r\n\r\n.customize-brush-menu {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: var(--tg-theme-hint-color) var(--tg-theme-bg-color);\r\n}\r\n\r\n.customize-brush-menu,\r\n.customize-brush-menu * {\r\n  touch-action: pan-y;\r\n}\r\n\r\n.customize-brush-menu.transparent-background {\r\n  background-color: transparent;\r\n\r\n  text-shadow: 0px 0px 1px var(--tg-theme-bg-color), 0px 0px 1px var(--tg-theme-bg-color), 0px 0px 1px var(--tg-theme-bg-color);\r\n}\r\n\r\n.customize-brush-menu::-webkit-scrollbar {\r\n  display: block;\r\n  width: 8px;\r\n}\r\n\r\n.customize-brush-menu::-webkit-scrollbar-track {\r\n  background: var(--tg-theme-bg-color);\r\n}\r\n\r\n.customize-brush-menu::-webkit-scrollbar-thumb {\r\n  background-color: var(--tg-theme-hint-color);\r\n  border-radius: 4px;\r\n}\r\n\r\n\r\n\r\n.customize-brush-title {\r\n  color: var(--tg-theme-button-color);\r\n  font-size: 24px;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.customize-brush-about {\r\n  width: 100%;\r\n  min-height: 35px; \r\n  height: 35px; \r\n  padding: 8px;\r\n  margin-bottom: 5px;\r\n  box-sizing: border-box;\r\n  border-radius: 2px;\r\n  border: 1px solid var(--tg-theme-hint-color);\r\n  background-color: var(--tg-theme-bg-color);\r\n  color: var(--tg-theme-text-color);\r\n  font-size: 16px;\r\n  resize: vertical; /* Разрешаем менять только высоту */\r\n}\r\n\r\n.customize-brush-label {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  color: var(--tg-theme-text-color);\r\n  padding: 1px; \r\n  padding-left: 10px; \r\n  text-align: left;\r\n}\r\n\r\n.customize-brush-preview-row {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0px;\r\n  transform: translate(10px);\r\n  justify-content: space-between; \r\n}\r\n\r\n.customize-brush-slider {\r\n  width: 90%;\r\n  margin-top: 10px;\r\n  margin-right: 10%;\r\n  height: 20px;\r\n  background: var(--tg-theme-button-color);\r\n  opacity: 0.7;\r\n  border-radius: 5px;\r\n}\r\n\r\n.customize-brush-select {\r\n  width: 100%;\r\n  padding: 8px;\r\n  margin-top: 4px;\r\n  font-size: 16px;\r\n  border-radius: 8px;\r\n}\r\n\r\n\r\n.texture-selection {\r\n  width: 100%;\r\n  margin-top: 5px;\r\n  text-align: left;\r\n}\r\n\r\n.section-title {\r\n  margin-bottom: 10px;\r\n  color: var(--tg-theme-text-color);\r\n  padding-left: 10px; \r\n}\r\n\r\n.texture-options {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n}\r\n\r\n.texture-option {\r\n  width: 61px;\r\n  height: 61px;\r\n  background: none;\r\n  color: var(--tg-theme-text-color);\r\n  border: none;\r\n  padding: 7px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  opacity: 0.7;\r\n  box-sizing: border-box;\r\n\r\n  border: 5.7px solid;\r\n  border-radius: 10px;\r\n  border-color: rgba(115, 185, 255, 0.3);\r\n}\r\n\r\n.texture-option.active {\r\n  color: var(--tg-theme-button-color);\r\n  border: 5.7px solid;\r\n  border-radius: 10px;\r\n  opacity: 1;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.texture-option canvas {\r\n  border-radius: 5px;\r\n  width: 50px;\r\n  height: 50px;\r\n  display: block;\r\n}\r\n\r\n.texture-option:hover:not(.active) {\r\n  background-color: rgba(154, 154, 154, 0.12);\r\n  border-radius: 12px;\r\n}\r\n\r\n.close-button {\r\n  position: absolute;\r\n  top: 0px; /* Отступ от верхнего края */\r\n  right: 0px; /* Отступ от правого края */\r\n  background: none;\r\n  border: none;\r\n  color: gray; /* Цвет крестика */\r\n  font-size: 20px; /* Размер крестика */\r\n  cursor: pointer;\r\n}\r\n\r\n.close-button:hover {\r\n  color: darkgray; /* Цвет при наведении */\r\n}\r\n\r\n.button-small-icon {\r\n  width: 15px;\r\n  height: 15px;\r\n  vertical-align: middle;\r\n  margin-right: 3px;\r\n  margin-top: -3px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
